<!-- grille 2 colonnes sur desktop -->
<div class="flex flex-col h-full">
<div class="grid grid-cols-1 lg:grid-cols-2 items-start gap-8 flex-1 overflow-y-auto">

    @if(!_orderWizardService.loading$()) {
        <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
    }
    @else {
        <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
    }
    
    <ng-template #component_loaded>
           <form [formGroup]="form!">
            <!-- order -->
            <div [formGroupName]="_orderWizardService.modelNames.step01.key">
                <div [formArrayName]="_orderWizardService.modelNames.step01.fields.currencyPurchaseList.key">
                    @let currencyPurchaseList = _orderWizardService.getFormArray(x=>x.step01?.currencyPurchaseList).controls; 
                    @for(currencyPurchase of currencyPurchaseList; track $index; let i = $index) {
                        <!-- @let direction = _orderWizardService.orderWizard$()?.step01?.currencyPurchaseList?.[i]?.direction; -->
                        <div class="bg-secondary-600 dark:bg-[#0c1427] text-white shadow-xl rounded-xl p-5 pt-0 mb-5 relative" >
                            <div [formGroupName]="i">
                                <div class="relative flex items-center justify-between h-12">
                                    <div class="text-sm">
                                        <!-- div_01: Select your currency -->
                                        {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.div_01' | translate }}
                                    </div>
                                    
                                    @if(i>0) {
                                        <div class="relative group inline-block">
                                            <button 
                                                (click)="openDeleteModal($index)"
                                                class="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shadow"> 
                                                <span class="material-symbols-outlined !text-[16px]">
                                                    delete
                                                </span>
                                            </button>
                                            <!-- Tooltip -->
                                            <div class="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 
                                                        whitespace-nowrap px-2 py-1 text-xs text-white 
                                                        bg-gray-800 rounded opacity-0 group-hover:opacity-100 
                                                        transition pointer-events-none">
                                                 <!-- span_01: Delete currency -->
                                                {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.span_01' | translate }}
                                            </div>
                                        </div>
                                    }

                                </div>
                              
                                <div class="grid lg:grid-cols-6 gap-x-5 gap-y-0 items-center ">
                                    <div class="col-span-6 mb-2">
                                        <corp-dropdown 
                                            corp-size="md"
                                            [formControlName]="_orderWizardService.modelNames.step01.fields.currencyPurchaseList.fields.targetCurrency.key"
                                            [options]="_orderWizardService.filteredListTarget()!"
                                            >
                                        </corp-dropdown>
                                    </div>

                                    <div class="col-span-6 flex justify-between mb-2">
                                        <!-- Bloc gauche -->
                                        <div class="flex flex-col">
                                            <div class="flex items-center gap-1 text-xs md:text-sm text-white-700 dark:text-white-200">
                                                <!-- @let prefixCurrency = _orderWizardService.orderWizard$()?.step01?.currencyPurchaseList?.[i];
                                                @let sourceSymbol = direction==currencyDirection.SourceToTarget 
                                                    ?  prefixCurrency?.sourceCurrency?.symbol! 
                                                    :  prefixCurrency?.targetCurrency?.symbol!;
                                                @let targetRate = direction==currencyDirection.SourceToTarget 
                                                    ?  prefixCurrency?.targetCurrency?.sellRate!
                                                    :  prefixCurrency?.targetCurrency?.sellRateReverse;
                                                @let targetSymbol = direction==currencyDirection.SourceToTarget 
                                                    ?  prefixCurrency?.targetCurrency?.symbol! 
                                                    :  prefixCurrency?.targetCurrency?.symbol!; -->
                                                @let prefixCurrency = _orderWizardService.orderWizard$()?.step01?.currencyPurchaseList?.[i];
                                                @let sourceSymbol = prefixCurrency?.sourceCurrency?.symbol!;
                                                @let targetRate = prefixCurrency?.targetCurrency?.sellRate!;
                                                @let targetSymbol = prefixCurrency?.targetCurrency?.symbol!;

                                                <span class="font-medium">
                                                    <!-- span_03: Convert -->
                                                    {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.span_03' | translate }}
                                                    :
                                                </span>
                                                <span>1</span>
                                                <span>{{ sourceSymbol }}</span>
                                                <span class="material-symbols-outlined">
                                                    line_end_arrow_notch
                                                </span>
                                                <span>{{ targetRate }}</span>
                                                <span>{{ targetSymbol }}</span>
                                            </div>
                                        <!-- <div>
                                            <span class="font-medium">
                                                i18n: Minimum available denomination 
                                                {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.span_04' | translate }}
                                                :
                                            </span>
                                            {{prefixCurrency?.targetCurrency?.denominationMin}} {{prefixCurrency?.targetCurrency?.symbol}} 
                                        </div> -->
                                        </div>

                                        <!-- Bloc droite -->
                                        <div>
                                            <!-- <button 
                                                class="group inline-flex items-center px-1 py-1 rounded-lg bg-secondary-50 hover:bg-secondary-100 border border-secondary-200 transition-all duration-200"
                                                (click)="toggleDirection($index)">
                                                <i class="material-symbols-outlined text-secondary-600 transition-transform duration-200 group-hover:rotate-180">
                                                    swap_horiz
                                                </i>
                                            </button> -->
                                        </div>
                                    </div>

                                    <div class="col-span-6 flex justify-between">
                                        @let prefixControlName=_orderWizardService.modelNames.step01.fields.currencyPurchaseList.fields;
                                        @let prefixSuffixName = _orderWizardService.orderWizard$()?.step01?.currencyPurchaseList?.[i];
                                        
                                        <div class="mr-2"> 
                                            <!-- @if(direction==currencyDirection.SourceToTarget) { -->
                                                <!-- corp-size="xl" -->
                                                <corp-input-decimal 
                                                    [decimals]="2"
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.sourceAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.sourceCurrency?.symbol!">
                                                </corp-input-decimal>

                                                <!-- <corp-input 
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.sourceAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.sourceCurrency?.symbol!"
                                                /> -->
                                            <!-- }
                                            @else {
                                                <corp-input-decimal 
                                                    [decimals]="2"
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.targetAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.targetCurrency?.symbol!">
                                                </corp-input-decimal> -->

                                                <!-- <corp-input 
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.targetAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.targetCurrency?.symbol!"
                                                /> -->
                                            <!-- } -->
                                        </div>

                                        <!-- <button 
                                            class="group inline-flex items-center px-1 py-1 rounded-lg bg-secondary-50 hover:bg-secondary-100 border border-secondary-200 transition-all duration-200"
                                            (click)="toggleDirection($index)">
                                            <i class="material-symbols-outlined text-secondary-600 transition-transform duration-200 group-hover:rotate-180">
                                                swap_horiz
                                            </i>
                                        </button> -->


                                        <div class="ml-2"> 
                                            <!-- @if(direction==currencyDirection.SourceToTarget) { -->
                                                <corp-input-decimal 
                                                    [decimals]="2"
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.targetAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.targetCurrency?.symbol!">
                                                </corp-input-decimal>

                                                <!-- <corp-input 
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.targetAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.targetCurrency?.symbol!"
                                                /> -->
                                            <!-- }
                                            @else {
                                                <corp-input-decimal 
                                                    [decimals]="2"
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.sourceAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.sourceCurrency?.symbol!">
                                                </corp-input-decimal> -->

                                                <!-- <corp-input 
                                                    [corp-loading]="_orderWizardService.loadingCurrencyValue$()"
                                                    [formControlName]="prefixControlName.sourceAmount.key"
                                                    [corp-suffix]="prefixSuffixName?.sourceCurrency?.symbol!"
                                                /> -->
                                            <!-- } -->
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    @if(_orderWizardService.loadingCurrencyCreation$()) {
                        <ng-container [ngTemplateOutlet]="component_loading_creation"></ng-container>
                    }
                   
                </div>

            </div>


            <button 
                (click)="addCurrencyPurchase()"
                class="block w-full lg:text-[15px] xl:text-md mt-[5px] md:mt-[12px] lg:mt-[20px] xl:mt-[25px] py-[12px] px-[17px] bg-primary-500 text-white rounded-md transition-all font-medium hover:bg-primary-600 text-center">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                    <i class="inline-block material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                        masked_transitions_add
                    </i>
                    <!-- span_02: Add currency -->
                    {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.span_02' | translate }}
                </span>
            </button>
        </form>

        <div>
            <order-purchase-summary [showAlert]=true></order-purchase-summary>
        </div>
    </ng-template>
</div>
</div>

<corp-modal [active]="isActive" title="Suppression">
    <div class="trezo-card-content pb-[20px] md:pb-[25px]">
        <!-- i18n - Do you confirm the deletion? -->
        {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.div_02' | translate }}
    </div>
    <div class="trezo-card-footer flex items-center justify-between -mx-[20px] md:-mx-[25px] px-[20px] md:px-[25px] pt-[20px] md:pt-[25px] border-t border-gray-100 dark:border-[#172036]">
        <button class="inline-block py-[5px] px-[30px] bg-secondary-500 text-white transition-all hover:bg-secondary-400 rounded-md border border-secondary-500 hover:border-secondary-400" type="button" (click)="isActive=false">
            <!-- i18n - Cancel -->
            {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.button_01' | translate }}
        </button>
        <button class="inline-block py-[5px] px-[30px] bg-primary-500 text-white transition-all hover:bg-primary-400 rounded-md border border-primary-500 hover:border-primary-400 ltr:mr-[11px] rtl:ml-[11px] mb-[15px]" 
            type="button"
            (click)="confirmDelete()">
            <!-- i18n - Cancel -->
            {{ 'i18n.app.features.pages.order.wizard.step_01.purchase.button_02' | translate }}
        </button>
    </div>
</corp-modal>

<ng-template #component_loading>
    <corp-loading [corp-label] = "'i18n.app.features.pages.loading.load' | translate"></corp-loading>
</ng-template>

<ng-template #component_loading_creation>
    <corp-loading [corp-label] = "'i18n.app.features.pages.loading.creation' | translate"></corp-loading>
</ng-template>




